module.exports = function getResource(label, vars = []) {
    const resources = {
        searchResults: 'Résultats de recherche',
        sale: 'Solde',
        resultsFor: `${vars[0]} résultats pour *${vars[1]}*`
    };

    return resources[label];
};
